import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { useSiteContent } from '@/context/SiteContentContext';

/**
 * Custom Design mode hero — a straightforward, clean hero section
 * with no animations or complex layouts. Visually distinct from
 * the Hydra themed hero variants.
 */
export const CustomHero: React.FC = () => {
  const ctx = useSiteContent();

  const phone = ctx.template.contact?.phone || '';

  return (
    <section className="bg-gray-50 border-b border-gray-200">
      <div className="container mx-auto px-4 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badges */}
          {ctx.heroBadges.length > 0 && (
            <div className="flex flex-wrap justify-center gap-2 mb-6">
              {ctx.heroBadges.map((badge, i) => (
                <span
                  key={i}
                  className="inline-flex items-center px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600"
                >
                  {badge}
                </span>
              ))}
            </div>
          )}

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            {ctx.heroHeadline}
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            {ctx.heroSubheadline}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-medium rounded-md hover:bg-gray-800 transition-colors"
            >
              {ctx.heroCTAPrimary}
              <ArrowRight className="h-4 w-4" />
            </Link>
            {phone && (
              <a
                href={`tel:${phone.replace(/\D/g, '')}`}
                className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors"
              >
                <Phone className="h-4 w-4" />
                {ctx.heroCTASecondary}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
